import { sportsApiUrl } from '../utils/apiUrls';

const unsubcribe = async ({ token }) => {
    try {
        const unsubscribeUrl = `${sportsApiUrl}/user-email-subscriptions?emailSubscriptionKey=${encodeURIComponent(
            token,
        )}`;
        const unsubcribeRes = await fetch(unsubscribeUrl, {
            method: 'delete',
            headers: {
                'content-type': 'application/json',
            },
        });

        if (unsubcribeRes.status !== 204) {
            const error = new Error(
                unsubcribeRes.statusText ||
                    unsubcribeRes.status ||
                    unsubcribeRes.message,
            );
            error.response = unsubcribeRes;
            throw error;
        }

        return unsubcribeRes.status === 204;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
};

export default unsubcribe;
